import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CompanyNavBar from "../Components/companyNavBar";
import ProductVisual from "../Components/Visual/productVisual";
import Footer from "../Components/footer";
import ResultCard from "../Components/resultCard";
import ProductDetails from "../Components/productDetails";
import config from "../Api/config";
import { DatabaseProduct, DatabaseVariant } from "../Api/Database";
import { toast } from "react-toastify";
import { VariantCard } from "../Components/Users/VariantCard";

function ProductPage() {


    const { product } = useParams();
    const [productData, setProductData] = useState<any>({});
    const [parentData, setParentData] = useState<DatabaseProduct>();
    const [brandData, setBrandData] = useState<any>({});
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const [variants, setVariants] = useState<DatabaseVariant[]>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [images, setImages] = useState<any>([]);

    // Fetch initial product data
    /*useEffect(() => {
        if(product != undefined ) {
            config.API.getProduct(product).then((item) => {
                setProductData(item);
            }).catch(error => {
                console.error("Error in API for product: ", error);
                notifyError("Error: " + error);
            });
        } 
    }, []);*/

    // Fetch product data - in case of variant swap only information
    useEffect(() => {
        if(product != undefined){
            config.API.getProduct(product).then((item) => {
                setLoading(true);
                setProductData(item);
                transformImg(item.image_gallery);
            }).catch(error => {
                console.error("Error in API for product: ", error);
                notifyError("Error: " + error);
            });
        }
    }, [product]);


    useEffect(() => {

        if(productData.id) {
            if(productData.parent_id != "" ){
                setLoading(false);
            }
    
            let variant = variants.find((value) => value.id == productData.id);
    
            if (!variant || variants.length === 0) {
                // get variants 
                config.API.getVariantList( productData.parent_id === "" ? productData.id : productData.parent_id, "","").then((el) => {
    
                    // If parent -> swap with variant data
                    if(productData.parent_id === "" && el.results.length > 0){
                        navigate(`/product/${el.results[0]["id"]}`);
                    }else{
                        setLoading(false);
                    }
    
                    setVariants(el.results);
                })
            }
    
            if(productData.owner_id && !brandData.id) {
    
                // get brand data for logo
                if(product !== undefined && Object.keys(productData).length !== 0){
                    config.API.getOwner(productData.owner_id).then((item) => {
                        setBrandData(item);
                    }).catch(error => {
                        console.error("Error in API for product: ", error);
                        notifyError("Error: " + error);
                    });
                }
            }
    
            if(!parentData) {
    
                // get parent information
                if (productData.parent_id && productData.parent_id !== '') {
                    config.API.getProduct(productData.parent_id).then(setParentData).catch((error) => {
                        console.error("Error in API for product: ", error);
                        notifyError("Error: " + JSON.stringify(error));
                    })
                } else {
                    setParentData(productData);
                }
            }
        }

    }, [productData]);

    function transformImg(images:any){
        let imgGallery:any[] = [];
        images.forEach((element:any) => {
            imgGallery.push({
                original: element,
                thumbnail: element,
            })
        });
        setImages(imgGallery);
    }

    
  return (
    <div className="product">
        <div className="explorerPublic">
            <CompanyNavBar data={brandData} product={true}/>
            {loading ? 
                <div className="explorer">
                    <div className="loading-page">
                        <div>Loading </div>
                        <div className="lds-dual-ring" style={{paddingBottom:"14px"}}></div>
                    </div>
                </div>
            : <>
                <ProductVisual brand={brandData} parentProduct={parentData}/>
                {Object.keys(productData).length !== 0 &&  <ResultCard data={productData} />}
                {Object.keys(productData).length !== 0 &&  <VariantCard data={variants} selected={product}/>}
                {Object.keys(productData).length !== 0 && Object.keys(brandData).length !== 0 &&  <ProductDetails productData={productData} brandData={brandData} images={images} />}
            </>}
        </div>
     
        <Footer />
  </div>
  );
}
export default ProductPage;
